import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

export default class Themes {
  constructor(token) {
    const { wed_id } = token.token_payload
    const token_bearer = `Bearer ${token.token}`
    const url = `${API_URL}/v1/wedsites/${wed_id}/theme`
    axios.defaults.baseURL = url
    axios.defaults.headers.common['Authorization'] = token_bearer
  }

  getThemeCustomizations(theme_id) {
    return axios.get(`/${theme_id}`).catch(() => ({}))
  }

  updateThemeCustomizations(data) {
    return axios.put('/', data)
  }
}
